let player;
let isMobile = false;
class VideoBanner {
  public iframeVid: any;
  active: boolean;

  constructor(){
    this.init();
  }

  init(){
    this.detectIsMobile();
    this.iframeVid = document.getElementById("iframe-video-bg");
    if (this.iframeVid) {
      if (isMobile) {
        // console.log("this is mobile");
        let videoId = this.iframeVid.dataset.id;
        if (videoId) {
          let videoContainer = document.querySelector("#yt-video-container");
          let videoBtns = document.querySelector("#yt-video-banner-btns");
          let thumbnailImage = document.createElement("img");
          let mobileBackgroundImage = document.getElementById("mobile-bg");
          
          //get thumbnail from youtube, if no mobile background image is selected
          if(mobileBackgroundImage != null){
            let videoMobileImageUrl = mobileBackgroundImage.getAttribute("data-src-mobile");

            if(videoMobileImageUrl != null && videoMobileImageUrl != ""){
              thumbnailImage.src = videoMobileImageUrl;
              thumbnailImage.alt = "Video Banner Background";
            }else{
              thumbnailImage.src = "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg";
              thumbnailImage.alt = "Video Banner Background";
            }
          }else{
            thumbnailImage.src = "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg";
            thumbnailImage.alt = "Video Banner Background";
          }
          if (videoContainer) {
            videoContainer.classList.add("mobile-iframe-wrapper");
            if (videoBtns) {
              videoBtns.classList.add("d-none");
            }
            videoContainer.appendChild(thumbnailImage);
          }
        }
      } else{ 
        //load YouTube API & include the youtube iframe api via script tag.
        const scriptTag = document.createElement("script");
        scriptTag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
      }
    }

    (<any>window).onYouTubeIframeAPIReady = () => {
      let videoId = this.iframeVid.dataset.id;
      player = new (<any>window).YT.Player("iframe-video-bg", {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          playsinline: 1,
          mute: 1,
          controls: 0,
          showinfo: 0,
          rel: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          playlist: videoId,
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
    };
  }

  //triggered when video player is ready
  onPlayerReady(event) {
    let playButton = document.getElementById("play-btn");
    let pauseButton = document.getElementById("pause-btn");

    if(playButton){
      playButton.addEventListener("click", function () {
        player.playVideo();
        pauseButton.classList.remove("d-none");
        playButton.classList.add("d-none");
      });
    }
    
    if (pauseButton) {
      pauseButton.addEventListener("click", function () {
        player.pauseVideo();
        playButton.classList.remove("d-none");
        pauseButton.classList.add("d-none");
      });
    }

    if (player.getPlayerState() == 2) {
      playButton.classList.remove("d-none");
      pauseButton.classList.add("d-none");
    } else {
      event.target.playVideo();
      pauseButton.classList.remove("d-none");
      playButton.classList.add("d-none");
    }
  }
  //triggered when the player's state changes.
  onPlayerStateChange(event) {
    if (event.data == window["YT"].PlayerState.ENDED) {
      event.target.playVideo();
    }
  }

  detectIsMobile(){
    let vw = window.innerWidth;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      isMobile = true;
    }
    return isMobile;
  }
}
export default VideoBanner;
